// src/pages/profile/profile_componnent_edit/EditPhone.jsx
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Stack, TextField, Typography } from "@mui/material";
import CustomButton from "../../../Components/CustomButton";

export default function EditPhone({ initialPhone, onCancel, onSubmit }) {
  const [phone, setPhone] = useState(initialPhone || "");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPhone(initialPhone || "");
  }, [initialPhone]);

  const handleSave = async () => {
    if (!phone.trim()) {
      setError(true);
      return;
    }
    setError(false);
    setLoading(true);
    try {
      await onSubmit({ phone: phone.trim() });
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <Stack spacing={2}>
      <Typography>Modification du numéro de téléphone</Typography>
      <TextField
        fullWidth
        label="Numéro de téléphone"
        placeholder="07 00 00 00 00"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        error={error && !phone.trim()}
        helperText={error && !phone.trim() ? "Le numéro est obligatoire" : ""}
      />
      <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
        <CustomButton type="secondaire" buttonText="Annuler" onClick={onCancel} />
        <CustomButton
          loading={loading}
          buttonText="Enregistrer"
          onClick={handleSave}
        />
      </Stack>
    </Stack>
  );
}

EditPhone.propTypes = {
  initialPhone: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
